/**
 * Backend rules of the subscription transfer the portal mirrors (technical-docs `api/cloud-api-v2.md`,
 * "Transfer a subscription to a tracker"). The backend still has the last word on each transfer.
 */

import { trackerProductForDevice } from './trackerProduct'
import type { Device } from '@/types/devices.api'

/** Runtime flag `window._env_.ITP_SUBSCRIPTION_TRADE_IN`: off hides the upgrade pages and every transfer offer */
export const isSubscriptionTradeInEnabled = (): boolean => window._env_?.ITP_SUBSCRIPTION_TRADE_IN === 'True'

/** Days the source keeps working after giving its subscription */
export const TRANSFER_SOURCE_GRACE_DAYS = 7

/** A target can receive a transfer when it has no recurring subscription and less than this many days left */
export const TRANSFER_TARGET_MAX_DAYS_LEFT = 7

/** Only a Pro Max (LWT7) is offered a transfer, whatever the backend would accept */
export const canReceiveTransfer = (device: Device | null | undefined): boolean => trackerProductForDevice(device) === 'proMax'

/** Only a Pro (LWT3) is offered as the source of a transfer, whatever the backend would accept */
export const canGiveTransfer = (device: Device | null | undefined): boolean => trackerProductForDevice(device) === 'pro'
